define('models/ConditionCode',[
	'core/can',
	'models/CodeModelConstructor',
	'text!content/js/ConditionCodes.json'
], function(can, CodeConstructor, json) {

	return CodeConstructor(json);
	
});
